import { Route } from "vue-router";
import { getModule } from "vuex-module-decorators";
import TitleListState from "@/modules/title-list";

export const WordPhraseSearchRouteResolver = async function (to: Route, from: Route, next: Function) {
	const actions: Promise<any>[] = [];
	const titleListModule = getModule(TitleListState);

	if (!titleListModule.languageSkills.length) {
		actions.push(titleListModule.fetchLanguageSkills());
	}
	if (!titleListModule.levels.length) {
		actions.push(titleListModule.fetchVcsLevels());
	}

	await Promise.all(actions);
	next();
};
